// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SuccessStep_wrapper__-jeHJ","title":"SuccessStep_title__14t4F","text":"SuccessStep_text__1Ay-j","link":"SuccessStep_link__27Plk","icon":"SuccessStep_icon__16OlY"};